export const MenuItems = [
  {
    //dropdowns
    title: "Marketing",
    path: "/marketing",
    cName: "dropdown-;link",
  },
  {
    //dropdowns
    title: "Consulting",
    path: "/consulting",
    cName: "dropdown-;link",
  },
  {
    //dropdowns
    title: "Design",
    path: "/design",
    cName: "dropdown-;link",
  },
  {
    //dropdowns
    title: "Development",
    path: "/development",
    cName: "dropdown-;link",
  },
];
